import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { CircularProgress, Box, Typography, alpha } from '@mui/material';
import AuthContext from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { user, loading, isAuthenticated } = useContext(AuthContext);
  const location = useLocation();

  // Debug logging
  console.log('[ProtectedRoute]', {
    path: location.pathname,
    loading,
    hasUser: !!user,
    userRole: user?.role,
    isAuthenticated,
    requiredRole
  });

  // Show loading spinner while checking auth
  if (loading) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '100vh',
          bgcolor: '#0a0e14',
          gap: 2
        }}
      >
        <CircularProgress sx={{ color: '#00d4ff' }} size={48} />
        <Typography sx={{ color: alpha('#fff', 0.5), fontSize: '0.9rem' }}>
          Checking authentication...
        </Typography>
      </Box>
    );
  }

  // Only redirect after loading is complete AND we're sure there's no user
  if (!user) {
    console.log('[ProtectedRoute] No user found, redirecting to login');
    // Save the attempted URL for redirecting after login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check role requirement
  if (requiredRole && user.role !== requiredRole) {
    console.log(`[ProtectedRoute] Role mismatch: required=${requiredRole}, actual=${user.role}`);
    return <Navigate to="/dashboard" replace />;
  }

  // All checks passed, render the protected content
  return children;
};

export default ProtectedRoute;



// import React, { useContext } from 'react';
// import { Navigate } from 'react-router-dom';
// import { CircularProgress, Box } from '@mui/material';
// import AuthContext from '../contexts/AuthContext';

// const ProtectedRoute = ({ children, requiredRole }) => {
//   const { user, loading } = useContext(AuthContext);

//   // Show loading spinner while checking auth
//   if (loading) {
//     return (
//       <Box 
//         sx={{ 
//           display: 'flex', 
//           justifyContent: 'center', 
//           alignItems: 'center', 
//           minHeight: '100vh',
//           bgcolor: '#0a0e14' // Match your app's background
//         }}
//       >
//         <CircularProgress sx={{ color: '#00d4ff' }} />
//       </Box>
//     );
//   }

//   // Only redirect after loading is complete
//   if (!user) {
//     return <Navigate to="/login" />;
//   }

//   if (requiredRole && user.role !== requiredRole) {
//     return <Navigate to="/dashboard" />;
//   }

//   return children;
// };

// export default ProtectedRoute;

